import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { qdfAPI } from '../../../services/api';
import { formatPpmReportDate } from '../utils/pendingPpmReport';

export const fetchPendingPpmEntries = async () => {
  const entries = [];
  let page = 1;
  let totalPages;
  do {
    const { data } = await qdfAPI.getReports({ maintenanceType: 'preventive', page, limit: 500 });
    if (!Array.isArray(data.reports) || !Number.isInteger(data.totalPages) || data.totalPages < 0 ||
        (page <= data.totalPages && data.reports.length === 0)) {
      throw new Error('Invalid PPM report response');
    }
    entries.push(...data.reports);
    totalPages = data.totalPages;
    page += 1;
  } while (page <= totalPages);
  return entries;
};

export const exportPendingPpmPdf = (report) => {
  const doc = new jsPDF({ orientation: 'landscape' });
  doc.setFontSize(16);
  doc.text('QDF BGM - Pending PPM Report', 14, 16);
  doc.setFontSize(10);
  const scope = [
    `As of: ${formatPpmReportDate(report.asOf)}`,
    'Scope: Active and On Hold preventive work orders only. Closed and Cancelled excluded.',
    `Filters: ${report.filters.location || 'All locations'} / ${report.filters.ppmType || 'All PPM types'} / ${report.filters.timing || 'All deadlines'}`,
    `Pending: ${report.pending} | Overdue: ${report.overdue} | On hold: ${report.onHold} | No due date: ${report.noDueDate}`,
    'Overdue uses target resolution time. Days overdue are rounded up. Only existing work orders are included.',
  ];
  const lines = scope.flatMap((line) => doc.splitTextToSize(line, 265));
  doc.text(lines, 14, 24);
  autoTable(doc, {
    startY: 28 + lines.length * 5,
    head: [['Location', 'PPM type', 'Pending', 'Overdue', 'On hold', 'No due date']],
    body: report.groups.map((group) => [
      group.location, group.ppmType, group.pending, group.overdue, group.onHold, group.noDueDate,
    ]),
    styles: { fontSize: 9 },
  });
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 10,
    head: [['SC number', 'Location / zone', 'Asset', 'PPM type', 'Scheduled', 'Target resolution', 'Status', 'Deadline', 'Days overdue', 'Contractor']],
    body: report.rows.map((row) => [
      row.scNumber || '-', row.place || '-', row.assetNumber || row.assetTag || '-',
      row.ppmType || '-', formatPpmReportDate(row.creationDate),
      formatPpmReportDate(row.targetResolution), row.scStatus, row.timing,
      row.overdue ? row.daysOverdue : '-', row.contractor || 'Not set',
    ]),
    styles: { fontSize: 8, overflow: 'linebreak' },
    rowPageBreak: 'avoid',
  });
  const pages = doc.internal.getNumberOfPages();
  for (let page = 1; page <= pages; page += 1) {
    doc.setPage(page);
    doc.setFontSize(8);
    doc.text(`Page ${page} of ${pages}`, 280, 203, { align: 'right' });
  }
  doc.save(`QDF-Pending-PPM-${report.asOf.slice(0, 10)}.pdf`);
};
